module.exports = __webpack_public_path__ + "img/tg.60fd0118.svg";